<template>
    <div>
        <MyTransition :myName="'up'">
            <div class="paper_popup" v-if="popupStatus && popup == 'sign'">
                <div class="flex flex_end close">
                    <button class="icon_btn btn_primary" @click="closeSign">
                        <i class="el-icon-close"></i>
                    </button>
                </div>
                <Popup>
                    <Sign :sign_name="sign_name" :index="sign_index" @transfromIMG="transfromIMG"></Sign>
                </Popup>
            </div>
        </MyTransition>
        <MyTransition :myName="'up'">
            <Popup v-if="popupStatus && popup !== 'sign'">
                <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
                <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
            </Popup>
        </MyTransition>
        <div class="paper_commit">
            <div class="form_input flex">
                <label> 表單號碼 </label>
                <div class="flex">
                    {{ this.options.application.form_id }}
                </div>
            </div>
            <div class="form_input flex">
                <label> 原事業單位名稱 </label>
                <div>錼創顯示科技股份有限公司</div>
            </div>
            <div class="form_input flex">
                <label> 施工日期 </label>
                <div class="time_range flex" v-if="!id">
                    {{ this.$moment().format("YYYY-MM-DD") }}
                </div>
                <div v-else>
                    {{ this.$moment(workData.created_at).format("YYYY-MM-DD") }}
                </div>
            </div>
            <div class="form_input flex">
                <label>作業名稱</label>
                <div class="width_220">
                    {{ formInput.name }}
                    <!-- <el-select
            value-key="id"
            v-model="formInput.name"
            placeholder="請選擇"
            :disabled="id !== null"
            @change="handlerID"
          >
            <el-option
              v-for="item in options.application"
              :key="item.id"
              :label="`${item.form_id}_${item.vendor.vendor_chinese}_${item.application.name}`"
              :value="item"
            ></el-option>
          </el-select> -->
                </div>
            </div>
            <div class="form_input flex">
                <label>施工區域</label>
                <div>
                    <p v-for="(area, i) in formInput.area" :key="i">
                        {{ area }}
                    </p>
                </div>
            </div>
            <div class="form_input flex">
                <label>工作場所負責人</label>
                <div>
                    <div>
                        {{ formInput.employee_sign }}
                    </div>
                </div>
            </div>
            <div class="form_input flex">
                <label>承攬商</label>
                <div>
                    <div v-for="(vendor, i) in formInput.vendors" :key="i">
                        {{ vendor.company_name }}
                    </div>
                </div>
            </div>
            <div class="form_input">
                <label>協議內容 </label>
                <div class="commit_textarea">
                    <div>遵循下列討論及協議事項，並依安全作業標準作業</div>
                    <textarea v-if="!id" class="input_primary" v-model="formInput.commit_content"></textarea>
                    <div v-else>
                        <!-- <div
              class="commit_textarea_item"
              v-for="(com, index) in workData.commit"
              :key="index"
            >
              {{ com.commit_content }}
            </div> -->
                        <div class="commit_textarea_item">
                            {{ workData["commit_content"] }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="commit_content">
            <div v-for="(item, index) in commitItem" :key="index">
                {{ index + 1 }}. {{ item }}
            </div>
        </div>
        <div class="form_input">
            <label>協議組織成員及簽名</label>
            <!--workData && id 都存在, 代表為admin確認表單簽核與填寫資料-->
            <!-- <div class="sign_list" v-if="workData && id">
        <div v-for="(sign, index) in formInput.sign_list" :key="index">
          <div>{{ sign.created_at }}</div>
          <div class="sign_item flex">
            <div class="sign_name">{{ formInput.vendor_sign }}</div>
            <div class="sign_btn">
              <img v-if="sign.vendor_sign2" :src="transImg(sign.vendor_sign2)" />
            </div>
          </div>
          <div class="sign_item flex">
            <div class="sign_name">{{ formInput.employee_sign }}</div>
            <div class="sign_btn">
              <img v-if="sign.employee_sign2" :src="transImg(sign.employee_sign2)" />
            </div>
          </div>
        </div>
        <div class="sign_item flex" v-for="(vendor,index) in formInput.vendors" :key="index">
          <div class="sign_name">{{ vendor.company_name }} / {{ vendor.supervisor.name }}</div>
          <div class="sign_btn">
            <img :src="showImg('vendor_sign', index)" />
            <button
              v-if="!id"
              class="btn_primary"
              @click="openSign({ key:index })"
            >
              簽名
            </button>
          </div>
        </div>
        <div class="sign_item flex">
          <div class="sign_name">{{ formInput.employee_sign }}</div>
          <div class="sign_btn">
            <img :src="showImg('employee_sign')" />
            <button
              v-if="!id"
              class="btn_primary"
              @click="openSign({ key: 'employee_sign' })"
            >
              簽名
            </button>
          </div>
        </div>
      </div> -->
            <div class="sign_list">
                <div class="sign_item flex flex_align_baseline flex_align_center"
                    v-for="(vendor, index) in formInput.vendors" :key="index">
                    <div class="sign_name">
                        {{ vendor.company_name }} / {{ vendor.supervisor.name }}
                    </div>
                    <div class="sign_btn">
                        <img :src="showImg('vendor_sign', index)" />
                        <button v-if="!id && !disabledBtn.vendor_sign[index]" class="btn_primary"
                            @click="openSign({ key: index })">
                            簽名
                        </button>
                    </div>
                </div>
                <div class="sign_item flex flex_align_baseline flex_align_center">
                    <div class="sign_name">{{ formInput.employee_sign }}</div>
                    <div class="sign_btn">
                        <img :src="showImg('employee_sign')" />
                        <button v-if="!id && !disabledBtn.employee_sign" class="btn_primary"
                            @click="openSign({ key: 'employee_sign' })">
                            簽名
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="commit_btn flex" v-if="!id">
            <button class="btn_gray" @click="returnLogin">返回</button>
            <button class="btn_primary" @click="enter">送出</button>
        </div>
    </div>
</template>

<style lang="scss">
.paper_commit {
    .paper_popup {
        position: relative;
    }

    .commit_textarea {
        margin-top: 10px;

        .commit_textarea_item {
            background: #efefef;
            padding: 15px 15px;
            border-radius: 5px;
            margin: 5px 0;
            white-space: pre-wrap;
        }
    }
}

.commit_content {
    border-bottom: 1px dashed #ccc;
    padding-bottom: 20px;
    font-size: 14px;

    >div {
        margin: 10px 0;
    }
}

.sign_list {
    .sign_item {
        margin: 10px 0;
        height: 100%;

        .sign_name {
            max-width: 100%;
            height: 100%;
        }

        .sign_btn {
            width: 400px;

            button {
                margin: 0 10px;
                width: 100px;
            }

            img {
                border: 1px solid #ccc;
                max-width: 230px;
            }
        }
    }
}

.commit_btn {
    .disable {
        cursor: not-allowed;
        // background: #ccc;
        border-radius: 5px;
    }
}
</style>
<script>
import mixins from "@/components/mixins.js";
import Options from "@/utils/options";
import Sign from "./SignCanvas";
export default {
    name: "new_paper-commit",
    mixins: [mixins],
    data() {
        return {
            formInput: {
                date: "",
                name: "",
                area: [],
                vendor: [],
                vendor_sign: [],
                employee_sign: null,
                //原來的 sign_img:{},
                sign_img: { employee_sign: "", vendor_sign: [] },
                commit_content: "",
            },
            sign_name: null,
            sign_index: null,
            options: {
                application: [],
                vendor: [],
            },
            workData: null,
            popupStatus: false,
            popup: null,
            successText: null,
            commitItem: [
                "首次會議時，原事業單位應將下列之應告知事項，詳細向各成員說明並要求其遵行。",
                "安全衛生自主管理之實施及配合。",
                "從事動火、高架、開挖、爆破、高壓電活線等危險作業之管制。",
                "對進入密閉空間、有害物質作業等作業環境之作業管制。",
                "電氣機具入廠管制。",
                "作業人員進場管制。",
                "變更管理事項。",
                "劃一危險性機械之操作信號、工作場所標識(示)、有害物空容器放置、警報、緊急避難方法及訓練等事項。",
                "使用打樁機、拔樁機、電動機械、電動器具、軌道裝置、乙炔熔接裝置、電弧熔接裝置、換氣裝置及沉箱、架設通道、施工架、工作架台等機械、設備或構造物時，應協調使用上之安全措施。",
                "有關本作業安全衛生管理、承攬管理項目應施行及配合之事項。",
                "共同作業之危害防止，各單位應配合、協調及應遵行事項(可依各細項作業分別討論)。",
                "工作場所之巡視，及監督、指揮體系、自動檢查的權責分配。",
                "原事業單位對相關承攬事業間之安全衛生教育之指導及協助事項。",
                "其他認有必要之協調事項。",
            ],
            sign_list: [],
            disabledBtn: {
                employee_sign: null,
                vendor_sign: [],
            },
        };
    },
    computed: {
        id() {
            return this.$route.query.work_id ? this.$route.query.work_id : null;
        },
        write() {
            //write_work_id代表這張commit的id
            return this.$route.query.write_work_id
                ? this.$route.query.write_work_id
                : false;
        },
        transImg() {
            return function (val) {
                return `${this.$http.base.storage}${val}`;
            };
        },
    },
    components: {
        Sign,
    },
    methods: {
        // getOneData() {
        //   const id = this.write ? this.write : this.id;
        //   this.$http.api.vendor.getNewDailyConstruction("", id).then((res) => {
        //     this.workData = res.data;
        //     console.log(res.data);
        //     // this.formInput.name = res.data.application.name;
        //     // //區分是編輯還是預覽
        //     // if (this.id) {
        //     //   this.formInput.sign_list = res.data.commit;
        //     // }
        //     //this.handlerID(res.data);
        //   });
        // },
        async getData() {
            //原來的 this.$http.api.vendor.getDailyConstruction().then((res) => {
            //   const today = this.$moment().format("YYYY-MM-DD");
            //   this.options.application = res.data.filter((el) => {
            //     return this.$moment(today).isSame(el.date);
            //   });
            // });
            //承攬商監工入廠填寫
            if (this.$route.query.write_work_id) {
                await this.$http.api.paper
                    .getCommit(this.$route.query.write_work_id)
                    .then((res) => {
                        //展開資料
                        this.workData = res.data;
                    });
                //console.log('commit id:',this.workData.new_work_id);
                //get FormInput Data
                await this.$http.api.vendor
                    .getNewConstruction("", this.workData.new_work_id)
                    .then((res) => {
                        //console.log(res.data);
                        //console.log("get FormInput Data");
                        //this.options.application = res.data[0].new_work;
                        this.options.application = res.data;
                        //處理承攬商及其監工
                        // for (
                        //     let i = 0;
                        //     i < this.options.application.vendors.length;
                        //     i++
                        // ) {
                        //     this.options.application.vendors[i].company_name =
                        //         res.data.vendor_chinese[i];
                        // }
                        //展開API Data to formInput
                        this.workData_id = this.options.application.id;
                        this.formInput.name = this.options.application.name;
                        this.formInput.area = this.options.application.area;
                        this.formInput.employee_sign =
                            this.options.application.employee.name;
                        this.formInput.vendors =
                            this.options.application.vendors;

                        if (this.is_role !== "vendor" && this.is_role != null) {
                            //處理承攬商及其監工
                            this.options.application.vendors.forEach(
                                (item, index) => {
                                    const new_op_list =
                                        this.options.vendor.find((vendor) => {
                                            return (
                                                vendor.vendor_id ==
                                                item.vendor_id
                                            );
                                        });
                                    item.company_name =
                                        new_op_list.vendor_chinese;
                                }
                            );
                        } else {
                            //處理承攬商及其監工
                            for (
                                let i = 0;
                                i < this.formInput.vendor.length;
                                i++
                            ) {
                                //console.log(i);
                                this.formInput.vendors[i].company_name =
                                    this.formInput.vendor[i];
                            }
                        }

                        if (this.workData.sign_list != null) {
                            this.formInput.sign_img = this.workData.sign_list;
                        } else {
                            console.log("空的sign");
                            this.formInput.sign_img = {};
                        }
                    });
            } else {
                //console.log("work_id:", this.$route.query.work_id);
                await this.$http.api.paper
                    .getCommit(this.$route.query.work_id)
                    .then((res) => {
                        console.log(res.data);
                        //展開資料
                        this.workData = res.data;

                        const haveValue = ["commit_content", "sign_list"];
                        for (const key of haveValue) {
                            const value = this.workData[key];
                            if (value !== null) {
                                if (key === "sign_list") {
                                    this.formInput.sign_img = value;
                                } else {
                                    this.formInput[key] = value;
                                }
                            } else {
                                this.formInput[key] = "";
                            }
                        }
                    });
                //get FormInput Data
                await this.$http.api.vendor
                    .getNewConstruction("", this.$route.query.new_work_id)
                    .then((res) => {
                        console.log("get FormInput Data");
                        this.options.application = res.data;
                        this.formInput.name = this.options.application.name;
                        this.formInput.area = this.options.application.area;
                        this.formInput.employee_sign =
                            this.options.application.employee.name;

                        this.formInput.vendors =
                            this.options.application.vendors;
                        if (this.is_role !== "vendor" && this.is_role != null) {
                            //處理承攬商及其監工
                            this.options.application.vendors.forEach(
                                (item, index) => {
                                    const new_op_list =
                                        this.options.vendor.find((vendor) => {
                                            return (
                                                vendor.vendor_id ==
                                                item.vendor_id
                                            );
                                        });
                                    item.company_name =
                                        new_op_list.vendor_chinese;
                                }
                            );
                        } else {
                            //處理承攬商及其監工
                            for (
                                let i = 0;
                                i < this.formInput.vendor.length;
                                i++
                            ) {
                                console.log(i);
                                this.formInput.vendors[i].company_name =
                                    this.formInput.vendor[i];
                            }
                        }
                    });
            }
            const haveValue = ["commit_content", "sign_list"];
            for (const key of haveValue) {
                const value = this.workData[key];
                if (value !== null) {
                    if (key === "sign_list") {
                        this.formInput.sign_img = value;
                    } else {
                        this.formInput[key] = value;
                    }
                } else {
                    //console.log(value);
                }
            }
        },
        async getTodayNewWork() {
            await this.$http.api.vendor.getNewDailyConstruction().then((res) => {
                //console.log(res.data);
                const data = res.data;
                const today_work = data.find((item) => {
                    //console.log(item);
                    // console.log(item.new_work.id);
                    // console.log(this.$route.query.new_work_id);
                    return item.new_work.id == this.$route.query.new_work_id;
                });
                //console.log("today_work", today_work);
                this.formInput.vendor = today_work.vendor_chinese;
                //console.log(this.formInput.vendor);
            });
        },
        // async getVendorData(vendor_id, item_index) {
        //     await this.$http.api.vendor.vendorBasisGet(vendor_id).then((res) => {
        //         this.formInput.vendors[item_index]["company_name"] =
        //             res.data.vendor_chinese;
        //         // 使用 this.$set 更新数组元素的属性
        //         // this.$set(this.formInput.vendors, item_index, {
        //         //     ...this.formInput.vendors[item_index],
        //         //     company_name: res.data.vendor_chinese,
        //         // });
        //     });
        // },
        async handlerID(e) {
            const area_data = await Options.getArea();
            this.formInput.area = area_data.filter((el) => {
                return e.area_id.includes(el.id);
            });
            this.workData = e;
            this.formInput.vendor = e.vendor.vendor_chinese;
            this.formInput.vendor_sign = e.supervisor.name;
            this.formInput.employee_sign = e.application.employee.name;
        },
        openSign({ key }) {
            console.log(key);
            this.popup = "sign";
            if (key == "employee_sign") {
                this.sign_name = key;
            } else {
                this.sign_name = "vendor_sign";
                this.sign_index = key;
            }
            this.popupStatus = true;
        },
        closeSign() {
            this.popupStatus = false;
        },
        transfromIMG(base64Img, name, index) {
            //原來的
            // this.closeSign();
            //console.log(name);
            // this.formInput.sign_img[name] = base64Img;
            this.closeSign();
            if (name === "employee_sign") {
                this.formInput.sign_img[name] = base64Img;
            } else {
                if (!this.formInput.sign_img[name]) {
                    this.$set(this.formInput.sign_img, [name], {});
                }
                this.formInput.sign_img[name][index] = base64Img;
            }
        },
        enter() {
            console.log("送單");
            const data = {
                sign_list: this.formInput.sign_img,
                commit_content: this.formInput.commit_content,
            };
            console.log(data);
            const id = this.$route.query.write_work_id;
            this.$http.api.paper
                .putCommit(id, data)
                .then((res) => {
                    this.popupStatus = true;
                    this.successText = "成功";
                    this.popup = "success";
                    //init
                    this.workData = null;
                    this.formInput.name = "";
                    this.formInput.area = [];
                    this.formInput.vendor_sign = [];
                    this.formInput.op_id = [];
                    this.formInput.sign_img = {};
                    this.formInput.commit_content = "";
                })
                .catch((error) => {
                    this.popupStatus = true;
                    this.popup = "error";
                    this.successText = `系統錯誤`;
                });

            // this.$http.api.paper
            //   .commit({
            //     work_id: this.workData.id,
            //     employee_sign: this.formInput.sign_img.employee_sign,
            //     vendor_sign: this.formInput.sign_img.vendor_sign,
            //     commit_content: this.formInput.commit_content,
            //   })
            //   .then((res) => {
            //     this.popupStatus = true;
            //     this.successText = "成功";
            //     this.popup = "success";
            //     //init
            //     this.workData = null;
            //     this.formInput.sign_img = {};
            //     this.formInput.commit_content = null;
            //   })
            //   .catch((error) => {
            //     this.popupStatus = true;
            //     this.popup = "error";
            //     this.successText = `系統錯誤`;
            //   });
        },
        poupupEnter() {
            this.popupStatus = false;
            if (this.popup == "success") {
                this.returnLogin();
            }
        },
        showImg(sign, index) {
            //console.log(this.formInput.sign_img[sign]);
            //確認能取到this.formInput.sign_img[sign]有東西(非null)
            if (this.formInput.sign_img[sign]) {
                //判斷sign是不是employee_sign
                if (sign === "employee_sign") {
                    const url = this.formInput.sign_img[sign].endsWith(".png");
                    if (!url) {
                        return this.formInput.sign_img[sign];
                    } else {
                        //console.log('return error');
                        this.disabledBtn[sign] = true;
                        return `${this.$http.base.storage}${this.formInput.sign_img[sign]}`;
                    }
                } else {
                    //確認能取到this.formInput.sign_img[sign][index]有東西(非null)
                    if (this.formInput.sign_img[sign][index]) {
                        const url =
                            this.formInput.sign_img[sign][index].endsWith(
                                ".png"
                            );
                        //確認圖片url的結尾是不是.png
                        if (!url) {
                            //代表為新增簽名
                            return this.formInput.sign_img[sign][index];
                        } else {
                            //代表為新增簽名
                            this.disabledBtn[sign][index] = true;
                            return `${this.$http.base.storage}${this.formInput.sign_img[sign][index]}`;
                        }
                    } else {
                        return "";
                    }
                }
            } else {
                return "";
            }
        },
    },
    async created() {
        if (this.is_role !== "vendor" && this.is_role != null) {
            //console.log('is_role:', this.is_role);
            this.options.vendor = await Options.getVendor();
        } else {
            await this.getTodayNewWork();
        }

        await this.getData();
        //this.getOneData();
    },
};
</script>
